import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import pipeline from './pipeline/pipeline.routes';
import home from './home/home.routes';
import flowsV2 from './flows-v2/flowsV2.routes';
import agenteIA from './agente-ia/agente-ia.routes';
import canales from './canales/canales.routes';
import envioMasivo from './envio-masivo/envio-masivo.routes';
import ventas from './ventas/ventas.routes';
import llamadas from './llamadas/llamadas.routes';
import miEquipo from './mi-equipo/mi-equipo.routes';
import tareas from './tareas/tareas.routes';
import catalogo from './catalogo/catalogo.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';

const AppContainer = () => import('./Dashboard.vue');
const Captain = () => import('./Captain.vue');
const Suspended = () => import('./suspended/Index.vue');

export default {
  routes: [
    ...helpcenterRoutes.routes,
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        {
          path: frontendURL('accounts/:accountId/captain'),
          name: 'captain',
          component: Captain,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        ...inboxRoutes,
        ...conversation.routes,
        ...pipeline.routes,
        ...home.routes,
        ...flowsV2.routes,
        ...agenteIA.routes,
        ...canales.routes,
        ...envioMasivo.routes,
        ...ventas.routes,
        ...llamadas.routes,
        ...miEquipo.routes,
        ...tareas.routes,
        ...catalogo.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
  ],
};
